import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
//import { useToasts } from 'react-toast-notifications'
import { AuthContext } from '../../Auth/Auth'
//import { useQuery, useMutation, useQueryClient } from 'react-query'
//import { Form, Col, Row, Modal } from 'react-bootstrap'
import { globalConfig } from '../../../config/config'
import { Loading } from '../../Loading/Loading'
import {
  InputAdornment,
  IconButton,
  TextField,
  Container,
  MenuItem,
  Tabs,
  Tab,
  Typography,
  Drawer,
  Button
} from '@mui/material';
import ProblemTicketSearch from './ProblemTicketSearch';

const ProblemTicketPage = () => {

	return (
		<>
			<ProblemTicketSearch />
			{/*
			   <div className="tabbable-custom nav-justified">		
			          <ul className="nav nav-tabs nav-justified">
			          <li id="tabCreate"><a href="#tab_create" data-toggle="tab">Create Ticket</a></li>
			          <li id="tabDetail"><a href="#tab_details" data-toggle="tab">Ticket Details</a></li>
			          <li id="tabFileViewer"><a href="#tab_viewer" data-toggle="tab">File Viewer</a></li>
			          <li id="tabSearch"><a href="#tab_search" data-toggle="tab">Ticket Search</a></li>
			          <li id="tabList" className="active"><a href="#tab_results" data-toggle="tab">Search Results</a></li>
			          </ul><div className="tab-content">
		        	<div className="tab-pane" id="tab_create">
			        	<form>
						<include src="ProblemTicketCreate"></include> 
						</form>
			        </div>
		        	<div className="tab-pane" id="tab_details">
			        	<form id="ProblemTicketDetailsForm">	
			 			<include src="ProblemTicketDetails"></include>  
			 			<include src="TicketAssets"></include>   
			 			</form>
			        </div>
 		        	<div className="tab-pane" id="tab_viewer">
			 			<form>
			 				 <include src="TicketFileManager"></include>  
			 			</form>
			 			<hr />
			        	<form>
		 				<include src="TicketFileViewer"></include> 
						</form>
			        </div>
		        	<div className="tab-pane" id="tab_search" >
	                    <form id="ProblemTicketSearchForm">
	                     <include src="ProblemTicketSearch"></include>   
	                    </form>
					</div>
		        	<div className="tab-pane active" id="tab_results" >
	                    <form>
	                    <include src="ProblemTicketSearchResults"></include>  
	                    </form>
	            	</div>
            	</div>
            </div>
            */}

  </>
  );
};

export default ProblemTicketPage;
